import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Logo from '../../images/SKIP.svg';
import axiosInstance from '../../api/api';
import { getUserFacingError } from '../../utils/userFacingError';
import { API_ROUTES } from '../../config/api-routes';
import { Button, Card, Col } from 'react-bootstrap';
import { toastSuccessOnce } from '../../utils/toastNotify';
import '../ResetPassword/resetPass.css';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const verifyStartedRef = useRef(false);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Verification link is invalid or missing a token.');
      return;
    }

    if (verifyStartedRef.current) {
      return;
    }
    verifyStartedRef.current = true;

    const verify = async () => {
      try {
        const response = await axiosInstance.post(
          API_ROUTES.AUTH.VERIFY_CODE,
          { token },
          { suppressErrorToast: true }
        );
        const data = response.data;
        if (data.success) {
          setStatus('success');
          toastSuccessOnce('email-verified', 'Verification successful. Please log in.');
          navigate('/', { replace: true });
        } else {
          setStatus('error');
          setMessage(data.message || data.detail || 'Verification failed.');
        }
      } catch (error: unknown) {
        setStatus('error');
        setMessage(getUserFacingError(error, 'Verification failed. The link may have expired.'));
      }
    };

    verify();
  }, [searchParams, navigate]);

  return (
    <div className="reset-main-wrapper">
      <Col sm={12} className="justify-content-center">
        <img
          className="mb-3"
          alt="Logo"
          src={Logo}
          width={150}
          style={{ display: 'block', margin: 'auto' }}
        />
        <Card className="p-5 success-wrapper">
          <h4 className="card-title text-center mb-4">Email Verification</h4>
          {status === 'loading' && (
            <Card.Text style={{ textAlign: 'center' }}>Verifying your email address…</Card.Text>
          )}
          {status === 'error' && (
            <>
              <Card.Text style={{ color: '#dc3545', textAlign: 'center' }}>{message}</Card.Text>
              <div className="text-center mt-3">
                <Link to="/" style={{ textDecoration: 'none', color: '#14a077' }}>
                  Back to login
                </Link>
              </div>
            </>
          )}
          {status === 'success' && (
            <Card.Text style={{ textAlign: 'center' }}>Redirecting you to login…</Card.Text>
          )}
          {status === 'loading' && (
            <div className="text-center mt-3">
              <Button variant="primary" disabled>
                Please wait
              </Button>
            </div>
          )}
        </Card>
      </Col>
    </div>
  );
};

export default VerifyEmail;
